
import { openTab } from 'utils/menuTab';


//全局js跳转方法
interface Config {
    path: string;
    title: string;
    search: string
}

window.openTab = (config: Config) => {
    const { path, title, search } = config || {};
    openTab({
        key: path,
        path: path,
        title,
        search,
    })
};

